import { render, staticRenderFns } from "./removed_findings.vue?vue&type=template&id=4b7d477c"
import script from "./removed_findings.vue?vue&type=script&lang=js"
export * from "./removed_findings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports